import { Smartphone } from 'lucide-react';

/**
 * MobileOnlyScreen - Pantalla de bloqueo para acceso desde escritorio
 *
 * Muestra un mensaje institucional pidiendo al usuario que acceda desde
 * un dispositivo móvil para aprovechar la experiencia completa de la app.
 *
 * Esta pantalla NO se puede saltear y solo aplica a usuarios participantes.
 * Los admins y sedes pueden acceder desde escritorio.
 */
export default function MobileOnlyScreen() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary via-primary-dark to-primary-light flex items-center justify-center p-6">
      <div className="max-w-md w-full">
        {/* Logo */}
        <div className="flex justify-center mb-8 animate-fade-in">
          <img
            src="https://muincpkiwzhuhqfhgzfa.supabase.co/storage/v1/object/public/APP/IconApp/IconApp.svg"
            alt="Liga Ajupam"
            className="w-32 h-32 drop-shadow-2xl"
          />
        </div>

        {/* Tarjeta principal */}
        <div className="bg-white rounded-3xl shadow-float p-8 text-center animate-fade-in" style={{ animationDelay: '0.1s' }}>
          {/* Icono de smartphone */}
          <div className="flex justify-center mb-6">
            <div className="bg-secondary rounded-full p-6 inline-block">
              <Smartphone className="w-12 h-12 text-primary" strokeWidth={2.5} />
            </div>
          </div>

          {/* Título */}
          <h1 className="font-display text-4xl text-primary mb-4 tracking-wide">
            ACCESO MÓVIL
          </h1>

          {/* Mensaje */}
          <p className="text-text-main text-lg leading-relaxed mb-6">
            Esta aplicación está diseñada para brindarte la mejor experiencia desde tu{' '}
            <span className="font-semibold text-primary">dispositivo móvil</span>.
          </p>

          <p className="text-text-muted text-base leading-relaxed">
            Para continuar, por favor accedé desde tu{' '}
            <span className="font-semibold">celular o tablet</span>.
          </p>

          {/* Separador decorativo */}
          <div className="flex items-center justify-center gap-2 my-6">
            <div className="h-px bg-primary/20 flex-1"></div>
            <div className="w-2 h-2 rounded-full bg-secondary"></div>
            <div className="h-px bg-primary/20 flex-1"></div>
          </div>

          {/* URL para copiar */}
          <div className="bg-surface-muted rounded-xl p-4">
            <p className="text-text-muted text-sm mb-2">Escaneá el QR o ingresá a:</p>
            <p className="font-mono text-primary font-semibold text-base break-all">
              liga.ajupam.ar
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-6 animate-fade-in" style={{ animationDelay: '0.2s' }}>
          <p className="text-white/80 text-sm">
            Liga Ajupam Padel
          </p>
        </div>
      </div>
    </div>
  );
}
